/* =========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default [
  {
    url: '/studio',
    name: 'Content',
    slug: 'content',
    icon: '',
  },
  {
    url: '/dashboard',
    name: 'Curriculums',
    slug: 'dashboard',
    icon: '',
  },
  {
    url: '/CreateEvent',
    name: 'Cast',
    slug: 'StartCast',
    icon: '',
  },
  {
    url: '/room',
    name: 'Room',
    slug: 'room',
    icon: '',
  },
  {
    url: '/team',
    name: 'Team',
    slug: 'team',
    icon: '',
  },
  {
    url: '/awards',
    name: 'Awards',
    slug: 'awards',
    icon: '',
  },
];
